import baseSignalRService from "./baseSignalRService";

class VOIPDataSignalRService extends baseSignalRService {
  url = '/hubs/voip/data';
  messagePackHubProtocol = true;
  receiveAudioStreamSubscription = null;

  Connect(agentConnectionId) {
    return this.send('Connect', agentConnectionId);
  }

  receiveAudioStream(callBack) {
    this.receiveAudioStreamSubscription = this.connection.stream('receiveAudioStream').subscribe({
      next: (encodedAudio) => callBack(encodedAudio),
      error: (err) => console.error(err)
    });
  }

  stopReceiveAudioStream() {
    if (this.receiveAudioStreamSubscription) {
      this.receiveAudioStreamSubscription.dispose();
      this.receiveAudioStreamSubscription = null;
    }
  }
}

export default new VOIPDataSignalRService();
